import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { FontFamily, Colors } from "../../styles/appStyles";
import TouchableOpacityLink from "../touchable-opacity-link";

const data = [
  {
    title: "Stories",
    link: "/all-stories",
  },
  {
    title: "Private",
    link: "/tmc-private",
  },
  {
    title: "Elevate",
    link: "/thought-leadership-programme",
  },
  {
    title: "On The Record",
    link: "/on-the-record",
  },
  {
    title: "Careers",
    link: "/careers",
  },
];

const BlackTopHeader = ({ currentPath }) => {
  return (
    <View style={styles.container}>
      <View style={styles.innerContainer}>
        {data.map((item) => (
          <TouchableOpacityLink to={item.link} key={item.title}>
            <Text
              style={[
                styles.linkText,
                currentPath === item.link
                  ? styles.activeLink
                  : styles.inactiveLink,
              ]}
            >
              {item.title}
            </Text>
          </TouchableOpacityLink>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#262a33",
    paddingVertical: 10,
    width: "100%",
  },
  innerContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 28,
    maxWidth: 1360,
    marginHorizontal: "auto",
    width: "100%",
    paddingHorizontal: 16,
  },
  linkText: {
    fontSize: 12,
    fontFamily: "HaasGrotesk-Medium",
    fontWeight: "500",
    letterSpacing: 0.5,
  },
  activeLink: {
    color: "#ffffff",
  },
  inactiveLink: {
    color: "#2cb680",
  },
});

export default BlackTopHeader;
